import { render } from "./CollaboratorFormFields.vue?vue&type=template&id=27c32631&scoped=true"
import script from "./CollaboratorFormFields.vue?vue&type=script&lang=js"
export * from "./CollaboratorFormFields.vue?vue&type=script&lang=js"

import "./CollaboratorFormFields.vue?vue&type=style&index=0&id=27c32631&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c32631"]])

export default __exports__